import { motion } from 'motion/react';

export interface SoldStatusPanelProps {
  title: string;
  subtitle?: string;
}

/**
 * SoldStatusPanel — confirmation panel после успешной buyback-продажи.
 * Зелёная подсветка accent, fade-in анимация (motion/react), две строки.
 *
 * Выделено из modules/reveal/WinnerStep.tsx (BuybackPanel при state='sold').
 */
export function SoldStatusPanel({ title, subtitle }: SoldStatusPanelProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 6 }}
      animate={{ opacity: 1, y: 0 }}
      data-co-component="SoldStatusPanel"
      className="
        w-full [border-radius:var(--co-SoldStatusPanel-borderRadius,28px)] border-2 [border-color:color-mix(in_srgb,var(--co-SoldStatusPanel-accent,var(--ui-accent))_40%,transparent)]
        [background:color-mix(in_srgb,var(--co-SoldStatusPanel-accent,var(--ui-accent))_15%,transparent)] px-4 py-4 text-center backdrop-blur
        [box-shadow:0_6px_22px_0_rgba(7,10,18,0.08)]
      "
    >
      <p className="text-[15px] leading-[22px] font-semibold text-[color:var(--co-SoldStatusPanel-accent,var(--ui-accent))] [font-family:var(--font-primary,var(--font-sans))]">
        {title}
      </p>
      {subtitle && (
        <p className="mt-1 text-[13px] leading-[20px] text-white/70 [font-family:var(--font-secondary,var(--font-sans))]">{subtitle}</p>
      )}
    </motion.div>
  );
}
